import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import TableContainer from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Table/TableContainer';
import Table from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Table/Table';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import TableHeader
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/Allocations/TableView/CollapsableTable/TableHeader';
import TableBody
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/Allocations/TableView/CollapsableTable/TableBody';
import { withParentSize } from '@visx/responsive';
import { FDStack } from '@facet-wealth/design';
import NoDataPlaceholderMessage from './NoDataPlaceholderMessage';

const styles = (theme) => ({
  root: {
    borderRadius: theme.radius.md,
    paddingBottom: theme.spacing(2),
    overflowX: 'scroll',
  },
  table: {
    width: '100%',
    borderCollapse: 'separate', // <--- Prevents sticky border from being collapsed on scroll
    '& .MuiTableCell-root': {
      borderBottom: 'none',
    },
    tableLayout: 'auto',
  },
  tableMobile: {
    '& td': {
      display: 'flex',
    },
    '& td:last-child': {
      textAlign: 'left',
    },
  },
});

const CollapsableTable = withParentSize(
  ({
    columns,
    data,
    className,
    classes,
    test,
    PlaceholderMessageProps,
    parentWidth,
    TopContent,
    height,
    showColumnLabels,
    onCellFormSubmitOverride,
    onLockRow,
  }) => {
    const isMobile = useMobileLayout();
    const hasTableData = (data && data.length >= 1 && columns);

    return (
      <TableContainer
        className={classNames(classes.root)}
        component={Paper}
        test={test}
        style={{
          maxWidth: parentWidth,
          height,
        }}
      >
        <FDStack direction={'column'} spacing={2}>
          {TopContent || null}
          {hasTableData ? (
            <Table
              className={classNames(classes.table, className, {
                [classes.tableMobile]: isMobile,
              })}
              aria-label={'collapsible allocation and strategies table'}
              stickyHeader
            >
              {showColumnLabels && <TableHeader columns={columns} />}
              <TableBody data={data} onCellFormSubmitOverride={onCellFormSubmitOverride} onLockRow={onLockRow} />
            </Table>
          ) : <NoDataPlaceholderMessage {...PlaceholderMessageProps} />
        }
        </FDStack>
      </TableContainer>
    );
  },
);

CollapsableTable.defaultProps = {
  className: '',
  columns: null,
  data: null,
  test: 'collapsable-allocation-table-view-root',
  PlaceholderMessageProps: {},
  TopContent: null,
  height: null,
  showColumnLabels: true,
  onCellFormSubmitOverride: null,
  onLockRow: null,
};

CollapsableTable.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  test: PropTypes.string,
  PlaceholderMessageProps: PropTypes.object,
  TopContent: PropTypes.node,
  height: PropTypes.number,
  showColumnLabels: PropTypes.bool,
  onCellFormSubmitOverride: PropTypes.func,
  onLockRow: PropTypes.func,
};

export default withStyles(styles)(CollapsableTable);
